import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import * as actions from "../../store/labTests/actions";
import TableGridView from "../../components/TableGridView";
import Filterform from "./Filterform";
import "./style.scss";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import { withStyles } from "@material-ui/styles";
import Switch from '@material-ui/core/Switch';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';

const MySwitch = withStyles((theme) => ({
  root: {
    width: 40,
    height: 24,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: "#FFF",
      '& + $track': {
        backgroundColor: '#24D7D3',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#24D7D3',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 22,
    height: 22,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const LabTests = ({ intl: { messages } }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [searchValues, setSearchValues] = useState({});
  const lang = localStorage.getItem("lang") || "en";
  const { labTests, labTestsStatistics } = useSelector((state) => state.labTests);
  const [blockConfirmation, setBlockConfirmation] = useState(false);
  const [selectedLab, setSelectedLab] = useState({});
  const user = useSelector((state) => state.auth?.user?.data);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);

  useEffect(() => {
    //Get internal Users list
    dispatch(
      actions?.getLabTestsRequest({
        page: 1,
        sort: "is_active,desc",
      })
    );
    dispatch(actions.getLabTestsStatisticsRequest());
    return () => {
      dispatch(actions.getLabTestsReceive([]));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //table n grid view render
  const headings = [
    messages.labTests.test_id,
    messages.labTests.arabic_name,
    messages.labTests.english_name,
    messages.labTests.ref_lab,
    messages.labTests.price_before,
    messages.labTests.price_after,
    messages.labTests.status,
    user?.role_id !== 4 && user?.role_id !== 6 && messages.labTests.actions,
  ];

  const renderTableData = () => {
    return labTests?.data?.map((lab, i) => {
      const {
        code,
        name,
        reference_lab,
        price_after_discount,
        price,
        is_active,
      } = lab;
      return [
        code,
        <Tooltip title={name.ar} placement="bottom" onClick={(e) => history.push(`/lab-tests/edit/${lab.id}`)} style={{ cursor: "pointer" }}>
          <span className="arabic_name">
            {name.ar.length > 25 ? `${name.ar.substring(0,25)}...` : name.ar}
          </span>
        </Tooltip>,
        <Tooltip title={name.en} placement="bottom" onClick={(e) => history.push(`/lab-tests/edit/${lab.id}`)} style={{ cursor: "pointer" }}>
          <span className="english_name">
            {name.en.length > 25 ? `${name.en.substring(0,25)}...` : name.en}
          </span>
        </Tooltip>,
        reference_lab.en,
        `${price_after_discount} ${messages.labTests.currency}`,
        `${price} ${messages.labTests.currency}`,
         <MySwitch checked={is_active === 1} name="block" 
                  onChange={() => {
                    if (is_active === 1) {
                      setSelectedLab(lab);
                      setBlockConfirmation(true);
                    } else {
                      dispatch(actions.activeLabTestRequest(lab.id));
                    }
                  }} 
                  disabled={user?.role_id === 4 || user?.role_id === 6}
                />,
        user?.role_id !== 4 && user?.role_id !== 6 && (<div className="actions-icons">
          <EditRoundedIcon onClick={() => history.push(`/lab-tests/edit/${lab.id}`)} />
          <DeleteForeverRoundedIcon onClick={() => {
            setSelectedLab(lab);
            setDeleteConfirmation(true);
          }}/>
        </div>),
      ];
    });
  };

  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.getLabTestsRequest({
        page,
        sort: "is_active,desc",
        ...searchValues,
      })
    );
  };

  console.log(labTestsStatistics)
  return (
    <>
      {labTests ? (
        <div style={{ padding: '5px 0'}}>
          {user?.role_id !== 4 && user?.role_id !== 6 && <button className={`myBtn ${lang === 'ar' && 'rtl'}`} 
              onClick={(e) => {e.preventDefault(); history.push("/lab-tests/add")}} >
              <AddCircleOutlineOutlinedIcon />{messages.labTests.add_new}
          </button>}
          <TableGridView
            title={
              <>
                <FormattedMessage
                  values={{
                    total: labTests?.total,
                    totals: labTestsStatistics?.total,
                  }}
                  id="labTests.labs_of"
                  defaultMessage={messages.labTests.labs_of}
                />
              </>
            }
            Form={<Filterform setSearchValues={setSearchValues} />}
            table={{
              stickyHeader: true,
              headings: headings,
              data: renderTableData(),
              headClass: "bg-white table-head",
              noData: messages.noData.no_data,
            }}
            //gridView={renderGridView}
            pagination={{
              count: labTests.last_page,
              page: labTests.current_page,
              handleChange: handlePageChange,
            }}
          />
        </div>
      ) : null}

      <ConfirmDialog show={blockConfirmation} 
                     onCancel={() => {
                        setBlockConfirmation(false)
                      }}
                     onConfirm={() => {
                        dispatch(actions.desactiveLabTestRequest(selectedLab.id))
                        setBlockConfirmation(false);
                     }}
                     content={messages.labTests.desactive_confirmation}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
      <ConfirmDialog show={deleteConfirmation} 
                     onCancel={() => {
                        setDeleteConfirmation(false)
                      }}
                     onConfirm={() => {
                        dispatch(actions.deleteLabTestRequest(selectedLab.id))
                        setDeleteConfirmation(false);
                     }}
                     content={messages.labTests.delete_confirmation}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
    </>
  );
};

export default injectIntl(LabTests);
